import { render, staticRenderFns } from "./AiMessageBubble.vue?vue&type=template&id=3f8c335c&scoped=true"
import script from "./AiMessageBubble.vue?vue&type=script&lang=js"
export * from "./AiMessageBubble.vue?vue&type=script&lang=js"
import style0 from "./AiMessageBubble.vue?vue&type=style&index=0&id=3f8c335c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8c335c",
  null
  
)

export default component.exports